export default __webpack_public_path__ + "static/media/bit-xnft.fa3c13a1.svg";